export function isFolder(__typename: string) {
  return __typename === 'FolderAsset';
}
